import React, { Component } from "react";

import { Link, Redirect } from "react-router-dom";

import { connect } from "react-redux";

import { signUp } from "../store/actions/authActions";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import { Helmet } from "react-helmet";

class Register extends Component {
  state = {
    menuToggled: false,
    step2: false,
    email: "",
    password: "",
    weight: "",
    height: "",
    age: "",
    gender: "",
  };

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmitOne = (e) => {
    this.setState({ step2: true });
    e.preventDefault();
  };

  componentDidMount() {}

  componentWillReceiveProps(newprops) {
    if (newprops.authError !== this.props.authError) {
      this.setState({ step2: false });
    }
  }

  render() {
    const { auth, authError, location } = this.props;
    const cameFromUpgrade =
      location.query && location.query.fromUpgrade
        ? location.query.fromUpgrade
        : false;
    if (auth.uid && cameFromUpgrade) return <Redirect to="/upgrade" />;
    if (auth.uid && !cameFromUpgrade) return <Redirect to="/" />;

    return (
      <div>
        <Helmet>
          <title>Create Account</title>
          <meta
            name="description"
            content="BoxFit is the ultimate home workout web-app
    with over 390 video exercises, 10 different workout categories and premium
    features such as Workout History & Weight Radar."
          />

          <meta property="og:url" content="https://www.boxfit-fitness.com/register" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="BoxFit is the ultimate home workout web-app
    with over 390 video exercises, 10 different workout categories and premium
    features such as Workout History & Weight Radar."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://www.boxfit-fitness.com/images/sharer.png"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={
            {
              /*height: "800px",
            width: "450px",
            borderRadius: "20px",
            boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",
            backgroundColor: "#000",*/
            }
          }
        >
          {this.state.step2 && (
            <div>
              <div style={{ height: "60px" }}></div>
              <div style={{ padding: "0px 20px 20px 20px" }}>
                <h2
                  style={{
                    fontSize: "22px",
                    color: "#69C9D0",
                    borderRadius: "2px",
                  }}
                >
                  Tell us more about yourself:
                </h2>

                <div className="wrappert">
                  <input
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "8px",
                      border: 0,
                      borderRadius: "4px",
                    }}
                    type="text"
                    placeholder="Enter your weight (optional)"
                    onChange={this.handleChange}
                    id="weight"
                  />
                </div>
                <div style={{ height: "20px" }}></div>

                <div className="wrappert">
                  <input
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "8px",
                      border: 0,
                      borderRadius: "4px",
                    }}
                    type="text"
                    placeholder="Enter your height (optional)"
                    onChange={this.handleChange}
                    id="height"
                  />
                </div>
                <div style={{ height: "20px" }}></div>

                <div className="wrappert">
                  <input
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "8px",
                      border: 0,
                      borderRadius: "4px",
                    }}
                    type="text"
                    placeholder="Enter your age (optional)"
                    onChange={this.handleChange}
                    id="age"
                  />
                </div>

                <div style={{ height: "20px" }}></div>

                <div className="wrappert">
                  <select
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "5px",
                    }}
                    onChange={this.handleChange}
                    id="gender"
                  >
                    <option value="none">Select your gender</option>
                    <option value="female">Female</option>
                    <option value="male">Male</option>
                  </select>
                </div>

                <div style={{ height: "20px" }}></div>

                <button
                  disabled={this.props.loading}
                  style={{
                    fontSize: "18px",
                    background: "#EE1D52",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                  onClick={() => {
                    // this.setState({ step2: false });
                    this.props.signUp(this.state);
                  }}
                >
                  <span role="img" aria-label="like">
                    🎉
                  </span>{" "}
                  {cameFromUpgrade
                    ? "Create Account and Go Premium"
                    : "Create Account"}
                </button>
                <div style={{ height: "5px" }}></div>
                <p>
                  By clicking on Create Account, you agree to BoxFit's{" "}
                  <Link style={{ color: "white" }} to="/terms">
                    Terms of Use
                  </Link>{" "}
                  and{" "}
                  <Link style={{ color: "white" }} to="/privacy">
                    Privacy Policy
                  </Link>
                  .
                </p>
              </div>
            </div>
          )}

          {!this.state.step2 && (
            <div>
              <div style={{ height: "60px" }}></div>
              <div style={{ padding: "0px 20px 20px 20px" }}>
                <form onSubmit={this.handleSubmitOne}>
                  <h2
                    style={{
                      fontSize: "22px",
                      color: "#69C9D0",
                      borderRadius: "2px",
                    }}
                  >
                    {cameFromUpgrade
                      ? "Create a new account and Go Premium"
                      : "Create a new account:"}
                  </h2>

                  <div className="wrappert">
                    <input
                      style={{
                        width: "100%",
                        height: "50px",
                        fontSize: "18px",
                        padding: "8px",
                        border: 0,
                        borderRadius: "4px",
                      }}
                      placeholder="Enter your email address"
                      onChange={this.handleChange}
                      id="email"
                      required
                      type="email"
                      value={this.state.email}
                    />
                  </div>
                  <div style={{ height: "20px" }}></div>

                  <div className="wrappert">
                    <input
                      style={{
                        width: "100%",
                        height: "50px",
                        fontSize: "18px",
                        padding: "8px",
                        border: 0,
                        borderRadius: "4px",
                      }}
                      type="password"
                      placeholder="Enter your password"
                      id="password"
                      onChange={this.handleChange}
                      required
                      minLength="5"
                    />
                  </div>

                  <div style={{ height: "20px" }}></div>

                  <button
                    style={{
                      fontSize: "18px",
                      background: "#EE1D52",
                      padding: "10px",
                      border: 0,
                      borderRadius: "4px",
                      fontWeight: "600",
                      width: "100%",
                      color: "white",
                    }}
                    /*onClick={() => {
                      this.setState({ step2: true });
                    }}*/
                  >
                    <span role="img" aria-label="like">
                      👉
                    </span>{" "}
                    Next
                  </button>
                  <div style={{ height: "20px" }}></div>
                  {authError && !this.props.loading ? (
                    <div style={{ color: "#EE1D52", fontSize: "18px" }}>
                      {authError}
                    </div>
                  ) : null}
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    auth: state.firebase.auth,
    loading: state.auth.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signUp: (creds) => dispatch(signUp(creds)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
